// extracted by mini-css-extract-plugin
export default {"container":"companyShow_container__di+Mg","tableCard":"companyShow_tableCard__kZla9","showCurrency":"companyShow_showCurrency__F2Dko"};